<template>
  <div class="page">
    <div class="content">
      <div class="title">
        1.您目前从事什么工作？
      </div>
      <div class="input">
        <van-field
          v-model.trim="form.work"
          type="textarea"
          maxlength="500"
          placeholder="您所在的行业及职业身份…"
        />
      </div>
      <div class="title">
        2.您一般使用灵云听语做什么？
      </div>
      <div class="input">
        <van-field
          v-model.trim="form.aim"
          type="textarea"
          maxlength="500"
          placeholder="您使用语音转文字的场景及目的…"
        />
      </div>
      <div class="title">
        3.您在使用灵云听语时有什么问题或建议？
      </div>
      <div class="input">
        <van-field
          v-model.trim="form.advice"
          type="textarea"
          maxlength="500"
          placeholder="您的问题或建议…"
        />
      </div>
    </div>
    <div class="submit">
      <div :class="{ disabled: disSubmit }" class="btn" @click="submit">提交并领取</div>
    </div>
  </div>
</template>

<script>
import { Field as vanField, Toast } from 'vant'
import { setToken } from '@/util/auth'
import { checkType, questionnaireCommit } from '@/api/collect'

export default {
  name: 'RewardCollect',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // console.log(from.path)
      // vm.from = from.path
      if (from.path === '/collect') {
        window.close()
      }
    })
  },
  components: {
    vanField
  },
  data () {
    return {
      form: {
        work: '',
        aim: '',
        advice: ''
      },
      from: ''
    }
  },
  computed: {
    disSubmit () {
      const { work, aim, advice } = this.form
      return !work || !aim || !advice
    }
  },
  methods: {
    async submit () {
      if (this.disSubmit) {
        // Toast('请填写内容后点击提交')
        return
      }
      try {
        const { work, aim, advice } = this.form
        const text = JSON.stringify([work, aim, advice])
        const res = await questionnaireCommit({
          type: '100000',
          text
        })
        if (res.data) {
          this.$router.push({
            path: '/collectRes',
            query: {
              status: 'success'
            }
          })
        } else {
          this.$router.push({
            path: '/collectRes',
            query: {
              status: 'fail'
            }
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async check () {
      try {
        const res = await checkType()
        if (res.data === 1) {
          this.$router.replace({
            path: '/collectRes',
            query: {
              status: 'success'
            }
          })
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  mounted () {
    window.androidToJs = async token => {
      if (token) {
        setToken(token)
        this.check()
      } else {
        Toast.fail('获取登录信息失败')
      }
    }
    window.getToken = token => {
      if (token) {
        setToken(token)
        this.check()
      } else {
        Toast.fail('获取登录信息失败')
      }
    }
  },
  beforeDestroy () {
    delete window.androidToJs
    delete window.getToken
  }
}
</script>

<style scoped lang="scss">
.page {
  padding-top: 400px;
  background-color: #4178B9;
  background-image: url(~@/assets/img/rewardCollect/BG@2x.png);
  background-size: 750px 680px;
  background-repeat: no-repeat;
  .content {
    height: 1320px;
    padding: 540px 64px 0;
    text-align-last: left;
    background-image: url(~@/assets/img/rewardCollect/pad@2x.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .title {
    text-align: left;
    font-size: 28px;
    color: #fff;
    margin-bottom: 20px;
    font-weight: 500;
    font-family: PingFang SC;;
  }
  .input {
    margin-bottom: 45px;
    .van-field {
      height: 180px;
      line-height: 70px;
      border-radius: 8px;
      padding: 16px;/*px*/
      & ::v-deep textarea {
        font-size: 28px;
      }
    }
  }
  .submit {
    padding: 48px 32px 64px;
    .btn {
      height: 112px;
      background-color: #FFE168;
      border-radius: 16px;
      text-align: center;
      line-height: 112px;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #602F0B;
      &.disabled {
        background-color: #ddd;
        color: #fff;
      }
    }
  }
}
</style>
